module.exports = Studio;


/*****************
 ** WEBPACK FOOTER
 ** external "Studio"
 ** module id = 4
 ** module chunks = 0
 **/